import {useQuery} from '@tanstack/react-query'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'

const useOptiversal = (query) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {configOptiversal} = commerceAPI.optiversal || {}

    var organizationID = null
    var relatedLinksUrl = null

    try {
        const jsonConfig = JSON.parse(configOptiversal)
        organizationID = jsonConfig.orgID
        relatedLinksUrl = jsonConfig.relatedLinksURL
    } catch (e) {
        console.log(e.message)
    }

    const init = async ({query, maxLinks, queryType}) => {
        const svcUrl = relatedLinksUrl
        const orgId = organizationID
        const apiUrl = `${svcUrl}?query=${query}&o=${orgId}&max=${maxLinks}&pageType=opt,plp&queryType=${queryType}`

        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                accept: 'application/json'
            }
        })
        return await response.json()
    }
    const enabledOptiversal = !!query && !isServer
    return useQuery({
        queryKey: ['use-optiversal', query],
        queryFn: () => init(query),
        enabled: enabledOptiversal
    })
}

export default useOptiversal
